module.exports = __webpack_public_path__ + "static/10-success-badge 1-bbaeb636e8c4a67ddd6b73da100e3db2.svg";